import type { PayMethodView } from "@frontend/components/collab/pay-now-dialog";
import type { CollabRoom } from "@creators/backend/lib/collabs/queries";
import { PAYMENT_METHOD_LABELS } from "@creators/backend/lib/collabs/payment-methods";
import { upiPaymentTarget } from "@creators/backend/lib/collabs/upi";

/** Payout methods the brand can use for one tranche, preferred method first. */
export async function payMethodsFor(
  room: CollabRoom,
  amountPaise: number,
): Promise<PayMethodView[]> {
  const details = room.payoutDetails;
  if (!details) return [];

  const preferred = details.defaultMethod;
  const methods: PayMethodView[] = [];

  const upi = await upiPaymentTarget({
    upiId: details.upiId,
    payeeName: room.creator.displayName,
    amountPaise,
    reference: room.collab.reference,
  });

  if (upi && details.upiId) {
    methods.push({
      key: "upi",
      label: PAYMENT_METHOD_LABELS.upi,
      preferred: preferred === "upi",
      upi: { id: details.upiId, uri: upi.uri, qrDataUri: upi.qrDataUri },
    });
  }

  if (details.bankAccountNumber && details.bankIfsc) {
    methods.push({
      key: "bank_transfer",
      label: PAYMENT_METHOD_LABELS.bank_transfer,
      preferred: preferred === "bank_transfer",
      bank: {
        accountNumber: details.bankAccountNumber,
        ifsc: details.bankIfsc,
        accountName: details.bankAccountName,
      },
    });
  }

  if (details.otherPayoutDetails) {
    methods.push({
      key: "other",
      label: PAYMENT_METHOD_LABELS.other,
      preferred: preferred === "other",
      other: details.otherPayoutDetails,
    });
  }

  return methods.sort((a, b) => Number(b.preferred) - Number(a.preferred));
}
